var rmUtil = require("../rmlibrary_old/util");
var characterMap;
var cnt = 0;
function PDFNode(node, pseudo, parent, content, styles) {
    this.originalNode = node;
    this.tagName = node.tagName && node.tagName.toLowerCase();
    this.pseudo = pseudo && pseudo.toLowerCase();
    this.parentElement = parent;
    this.content = content;
    this.styles = styles;
    this.lang =
        (typeof this.originalNode.getAttribute === "function" ? this.originalNode.getAttribute("lang") : null) ||
            parent.lang ||
            null;
    cnt++;
    var href = (this.tagName === "a" && this.originalNode.getAttribute("href")) || parent.href;
    // var href = parent.href || (parent.tagName === 'a' && parent.originalNode.getAttribute("href"));
    if (href) {
        this.href = href;
    }
}
PDFNode.getCount = function () {
    return cnt;
};
PDFNode.prototype.setChildren = function (children) {
    this.children = children;
};
PDFNode.prototype.toString = function (spacer) {
    if (!spacer)
        spacer = "";
    var str = spacer + "[" + this.constructor.name;
    if (this.tagName)
        str += " <" + this.tagName + ">";
    if (this.pseudo)
        str += "::" + this.pseudo;
    if (this.computedStyles) {
        str += " " + JSON.stringify(this.computedStyles);
    }
    else if (this.styles) {
        str += " " + JSON.stringify(this.styles);
    }
    if (this.content) {
        var strContent = this.content;
        if (strContent.length > 40)
            strContent = strContent.slice(0, 40) + "...";
        str += '"' + strContent + '"';
    }
    if (Array.isArray(this.children) && this.children.length) {
        str +=
            "\n" +
                this.children
                    .map(function (child) {
                    return child.toString(spacer + "  ");
                })
                    .join(",\n") +
                "\n" +
                spacer;
    }
    str += "]";
    return str;
};
PDFNode.prototype.getA11yProperties = function () {
    if (this.parentElement.tagName === "abbr") {
        return {
            role: "span",
            expanded: this.parentElement.originalNode.getAttribute("title"),
        };
    }
};
PDFNode.prototype.generate = function () {
    var replacedText = this.content;
    if (Array.isArray(characterMap)) {
        for (var i = 0; i < characterMap.length; i++) {
            if (typeof characterMap[i].pattern === "string") {
                replacedText = replacedText.split(characterMap[i].pattern).join(characterMap[i].replacement);
            }
            else {
                replacedText = replacedText.replace(characterMap[i].pattern, characterMap[i].replacement);
            }
        }
    }
    var ret = {
        size: this.computedStyles.size,
        lineHeight: this.computedStyles.lineHeight,
        font: this.computedStyles.font,
        italic: this.computedStyles.italic,
        bold: this.computedStyles.bold,
        color: this.computedStyles.color,
        align: this.computedStyles.align,
        letterSpacing: this.computedStyles.letterSpacing,
        transform: this.computedStyles.transform,
        underline: this.computedStyles.underline,
        overflowWrap: this.computedStyles.overflowWrap,
        wordWrap: this.computedStyles.wordWrap,
        text: replacedText,
        href: this.href || undefined,
        lang: this.lang || null,
        _originalNode: this.originalNode,
    };
    var a11yProperties = this.getA11yProperties();
    if (typeof a11yProperties === "object") {
        rmUtil.extend(ret, a11yProperties);
    }
    return ret;
};
PDFNode.setCharacterMap = function (map) {
    characterMap = map;
};
module.exports = PDFNode;
//# sourceMappingURL=module.js.map